/**
 * The resize direction options: 'north' | 'south'
 */
export var RowResizeDirection;
(function (RowResizeDirection) {
    RowResizeDirection["north"] = "north";
    RowResizeDirection["south"] = "south";
})(RowResizeDirection || (RowResizeDirection = {}));
